import React, {useState, Suspense, lazy} from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from  'react-router-dom';
// import Home from './Pages/Home';
import { useAuth } from './context/AuthContext';
import { GlobalStyle } from './styles/GlobalStyles';
import { FontStyle } from './fonts/FontStyles';
import ScrollToTop from './components/ScrollToTop';
import { Spinner } from 'react-bootstrap';
import Loading from './components/Loading';
// import CategoryDetail from './Pages/CategoryDetail';
// import ProductDetail from './Pages/ProductDetail';
// import Contact from './Pages/Contact';
// import About from './Pages/About';
// import Terms from './Pages/Legal/TermsCondition';
// import Process from './Pages/Process';
// import Careers from './Pages/Collaboration/Careers';
// import Bar from './components/Navigations/index';
// import Login from './Pages/Auth/Login';
// import Wishlist from './Pages/Auth/Wishlist';
// import ContactForm from './Pages/Auth/Contact';
// import Profile from './Pages/Auth/Profile';
// import Concept from './Pages/ConceptIdeas';
// import Project from './Pages/Project';
// import Subcategory from './Pages/Subcategory';
// import Timer from './components/Timer/index';
// import Shop from './Pages/Shop';
// import Supplychain from './Pages/Collaboration/supply';
// import Workshops from './Pages/Collaboration/workshops';
// import Sponsors from './Pages/Collaboration/sponsors';
// import Privacy from './Pages/Legal/Privacy';
const Home = lazy(() => import('./Pages/Home'));
const CategoryDetail = lazy(() => import('./Pages/CategoryDetail'));
const ProductDetail = lazy(() => import('./Pages/ProductDetail'));
const Contact = lazy(() => import('./Pages/Contact'));
const About = lazy(() => import('./Pages/About'));
const Terms = lazy(() => import('./Pages/Legal/TermsCondition'));
const Careers = lazy(() => import('./Pages/Collaboration/Careers'));
const Process = lazy(() => import('./Pages/Process'));
const Bar = lazy(() => import('./components/Navigations/index'));
const Login = lazy(() => import('./Pages/Auth/Login'));
const Wishlist = lazy(() => import('./Pages/Auth/Wishlist'));
const ContactForm = lazy(() => import('./Pages/Auth/Contact'));
const Profile = lazy(() => import('./Pages/Auth/Profile'));
const Concept = lazy(() => import('./Pages/ConceptIdeas'));
const Project = lazy(() => import('./Pages/Project'));
const Subcategory = lazy(() => import('./Pages/Subcategory'));
const Timer = lazy(() => import('./components/Timer/index'));
const Shop = lazy(() => import('./Pages/Shop'));
const Supplychain = lazy(() => import('./Pages/Collaboration/supply'));
const Workshops = lazy(() => import('./Pages/Collaboration/workshops'));
const Sponsors = lazy(() => import('./Pages/Collaboration/sponsors'));
const Privacy = lazy(() => import('./Pages/Legal/Privacy'));
// const Loading = lazy(() => import('./components/Loading'));

const ProtectedRoutes = props => {

  const { currentUser } = useAuth();
  const {path} = props;
  const location = useLocation();

  if(path === '/login' || path === '/reset-password'){
    return currentUser ? ( <Redirect to={location.state?.from ?? '/dashboard/wishlist'}/> ) : ( <Route {...props}/> )
  }

  return (
    (currentUser ? (<Route {...props}/>
      ) : (
      <Redirect 
      to={{
        pathname: '/login',
        state: {from: path},
       }}/>
      )
    )
  )
}

function Routes() {

return (
    <Router>
      <Suspense fallback={<Loading/>}>
      <Bar />
      <Timer/>
      <ScrollToTop/>
      <Switch>
        <Route path='/' component={Home} exact />
        <Route path='/about' component={About} exact />
        <Route path='/terms' component={Terms} exact />
        <Route path='/privacy' component={Privacy} exact />
        <Route path='/process' component={Process} exact />
        <Route path='/careers' component={Careers} exact />
        <Route path='/supplychain' component={Supplychain} exact />
        <Route path='/workshops' component={Workshops} exact />
        <Route path='/sponsors' component={Sponsors} exact />
        <Route path='/concepts' component={Concept} exact />
        <Route path='/projects' component={Project} exact />
        <Route path='/contact' component={Contact} exact />
        <Route path='/shop' component={Shop} exact />
        <ProtectedRoutes path='/login' component={Login} exact />
        <ProtectedRoutes path='/dashboard/wishlist' component={Wishlist} exact />
        <ProtectedRoutes path='/dashboard/contactform' component={ContactForm} exact />
        <ProtectedRoutes path='/dashboard/profile' component={Profile} exact />
        <Route path='/:category' component={CategoryDetail} exact />
        <Route path='/:category/:subcategory' component={Subcategory} exact />
        <Route path='/:category/:subcategory/:productId' component={ProductDetail} exact />
      </Switch>
      <FontStyle/>
      <GlobalStyle/>
      </Suspense>
    </Router>
)
}
export default Routes;